// Dominio de las cuentas de Google Workspace de la casa. Solo una cuenta de este
// dominio puede ser personal interno; con otro dominio (p. ej. Gmail) solo se entra
// como productor, si figura activo en el padrón (ver docs/productores.md). Las reglas
// de Firestore/Storage y las Cloud Functions aplican el mismo criterio.
export const AXON_EMAIL_DOMAIN = 'axoncapital.com.ar';

export const isAxonEmail = (email) =>
    typeof email === 'string' && email.trim().toLowerCase().endsWith(`@${AXON_EMAIL_DOMAIN}`);
